import styled from "styled-components";

const CocktailInstructions = styled.p`
  padding: 20px;
  text-align: center;
  color: rgba(0, 185, 205, 1);
`;

export default CocktailInstructions;
